import { buildDefaultMiddleware } from 'utilities/state';

export default buildDefaultMiddleware('video', 'store:video');